import { t as tns_1 } from "./tiny-slider-4942ccfd.mjs?v=1746656911949";
import { c as createApp } from "./vue.esm-bundler-7c366d63.mjs?v=1746656911949";
import { injectableComponent } from "./ProductCard.js?v=1746656911949";
import "./axios-b9f7d7b4.mjs?v=1746656911949";
import "./main.js?v=1746656911949";
import "./OrderConfirmed.vue_vue_type_style_index_0_lang-f2a76ad9.mjs?v=1746656911949";
const FeaturedCollection_vue_vue_type_style_index_0_lang = "";
const _sfc_main = function(props, element) {
  const components = {};
  const allProds = element.querySelectorAll(".product-card") || [];
  allProds.forEach((card) => {
    const productCard = injectableComponent("<div>" + card.outerHTML + "</div>");
    components["product-card-" + card.dataset.handle] = productCard;
    card.parentElement.removeChild(card);
  });
  return createApp(
    {
      name: "FeaturedCollection",
      delimiters: ["${", "}"],
      template: element.outerHTML,
      components,
      props: {
        collections: {
          type: Array,
          default: []
        },
        isRecommendations: {
          type: Boolean,
          default: false
        }
      },
      data() {
        return {
          mounted: false,
          currentCollection: this.$props.collections[0] || 0,
          featuredColSlide: null,
          currentPage: 1,
          totalPages: "0",
          collectionSliders: []
        };
      },
      mounted() {
        this.createSliders();
        this.mounted = true;
      },
      methods: {
        createSliders() {
          if (this.isRecommendations) {
            const collectionSlider = tns_1({
              container: `#recommended-section-slides`,
              items: 1.2,
              gutter: 16,
              mouseDrag: true,
              controls: false,
              nav: false,
              loop: false,
              preventScrollOnTouch: true,
              swipeAngle: 30,
              responsive: {
                768: {
                  slideBy: props.perPage,
                  items: props.perPage,
                  gutter: 24
                }
              }
            });
            if (!collectionSlider)
              return;
            const _this = this;
            collectionSlider.events.on("indexChanged", function(info, _eventName) {
              _this.currentPage = Math.ceil(
                (info.displayIndex + info.items - 1) / info.items
              );
              _this.totalPages = Math.ceil(info.slideCount / info.items);
            });
            this.featuredColSlide = collectionSlider;
            this.totalPages = Math.ceil(
              this.featuredColSlide.getInfo().slideCount / this.featuredColSlide.getInfo().items
            );
            return true;
          }
          for (const collectionId of this.collections) {
            const collectionSlider = tns_1({
              container: `#featuredProducts-${collectionId}`,
              items: 1.2,
              gutter: 16,
              mouseDrag: true,
              controls: false,
              nav: false,
              loop: false,
              preventScrollOnTouch: true,
              swipeAngle: 30,
              responsive: {
                768: {
                  slideBy: props.perPage,
                  items: props.perPage,
                  gutter: 24
                }
              }
            });
            const _this = this;
            collectionSlider.events.on("indexChanged", function(info, _eventName) {
              _this.currentPage = Math.ceil(
                (info.displayIndex + info.items - 1) / info.items
              );
              _this.totalPages = Math.ceil(info.slideCount / info.items);
            });
            this.collectionSliders[collectionId] = collectionSlider;
          }
          this.featuredColSlide = this.collectionSliders[this.currentCollection];
          this.totalPages = Math.ceil(
            this.featuredColSlide.getInfo().slideCount / this.featuredColSlide.getInfo().items
          );
        },
        setSlide(id) {
          this.currentCollection = id;
          this.featuredColSlide = this.collectionSliders[id];
          const info = this.featuredColSlide.getInfo();
          this.currentPage = Math.ceil(info.displayIndex / info.items);
          this.totalPages = Math.ceil(
            this.collectionSliders[id].getInfo().slideCount / this.collectionSliders[id].getInfo().items
          );
        }
      }
    },
    props
  );
};
export {
  _sfc_main as default
};
